import React from 'react';
import { useNavigate } from 'react-router-dom';

const QuestionSubmitPopup = ({ setQuestionStep, baraemUsername, translationMap }) => {
  const navigate = useNavigate();

  return (

    <div className="modal fade Custom_Modal_Box show" id="childdetailsmodal" tabindex="-1" role="dialog"
    aria-labelledby="exampleModalCenterTitle" aria-hidden="true" style={{ display: "block" }}>
            <div className="modal-dialog  CoveragePlan_Dialog3" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <div className="Title_Inner_Box">
                            <h6 className="MainTitleOne">
                                {translationMap?.quesSubmitted ?? "Questionnaire Submitted"}
                            </h6>
                        </div>
                    </div>
                    <div className="modal-body">
                        <div className="baraem_modal_body">
                            <div className="AlertInnerBox GreenAlertInnerBox alert">
                                <div className="Icon_box">
                                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, no-script-url */}
                                    <a href="javascript:void(0);">
                                        <span className="material-symbols-outlined">
                                            check_circle
                                        </span>
                                    </a>
                                </div>
                                <div className="alert_text">
                                    <h6>
                                        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, no-script-url */}
                                        <a href="javascript:void(0);">
                                            {translationMap?.quesSubmittedSuccess ?? "Questionnaire has been submitted successfully. You can download the report  from Bara’em main screen."}
                                        </a>
                                    </h6>
                                </div>
                            </div>
                            <div className="congrates_inner_box">
                                <h6 className="Gray_Title">
                                    {translationMap?.congrats ?? "Congrats!"}
                                </h6>
                                <p className="para_txt1">
                                    {translationMap?.yourchild ?? "Your child’s"}{" "}{baraemUsername}{" "}{translationMap?.normalRangeText ?? "development is within the normal range of age. Remember to keep track of their milestones using the Baraem questionnaire."}
                                </p>
                                <p className="para_txt2">
                                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                                    {translationMap?.shareFeedbackText ?? "You can share your feedback with us through this"} <a
                    onClick={() => setQuestionStep(9)}>{translationMap?.link ?? "link"}</a>.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="modal-footer modal_footer_btn_box2">
                        <button type="button" className="btn bluetrans_btn_link" data-dismiss="modal"
            onClick={() => navigate('/')}>
                            {translationMap?.close ?? "Close"}
                        </button>

                    </div>

                </div>
            </div>
        </div>);

};

export default QuestionSubmitPopup;